module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "play.1d4dd3d3.svg";